export default {
  appTitle: 'RatesBoard',
  apiUrl: 'https://api.ratesboard.local/api',
  appEnv: 'production',
  useMockServices: false,
};
